<template>
<div class="home-root">
<full-page ref="fullpage" :options="options">
    <!-- ============ 第一屏：首屏 Hero 轮播 ============ -->
    <div class="section section_1">
        <el-row class="navbar_container" :class="{'navbar_transparent': activeSection === 0}">
            <el-col :xs="12" :sm="6" :md="5" :lg="5" :xl="4" class="logo">
                <router-link to="/">
                  <el-image :src="navBar.sslogo">
                      <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                      </div>
                  </el-image>
                </router-link>
            </el-col>
            <el-col :sm="15" :md="15" :lg="15" :xl="16" class="nav hidden-sm-and-down">
                <router-link  :to="nav.index"  v-for="nav in navBar.navName" :key="nav.index" class="nav_link">
                  <el-button type="text">{{nav.name}}</el-button>
                </router-link>
                <a target="_blank" href="http://education.jsssjt.com" class="nav_link">
                  <el-button type="text">山水学堂</el-button>
                </a>
            </el-col>
            <el-col :xs="12" :sm="18" :md="4" :lg="4" :xl="4" class="btns">
                <span class="iconfont icon-line-search" @click="$jumpTo('/search')"></span>
                <span class="iconfont icon-line-open" @click="clickNavBar"></span>
            </el-col>
        </el-row>
        <div class="navSM_container hidden-md-and-up " :class="navBar.isShowNavBar ? 'open' : 'close'">
          <div class="navSM">
              <router-link  :to="nav.index"   v-for="nav in navBar.navName" :key="nav.index">
                  <el-button type="text">{{nav.name}}</el-button>
              </router-link>
               <a target="_blank" href="http://education.jsssjt.com">
                  <el-button type="text">山水学堂</el-button>
                </a>
          </div>
        </div>

        <div class="hero_carousel">
            <el-carousel class="hero_el_carousel" height="100%" direction="horizontal" :autoplay="true" :interval="5000" arrow="hover" @change="onSlideChange">
                <el-carousel-item v-for="banner in syBanners" :key="banner.articleid">
                    <div class="hero_slide">
                        <el-image class="hero_img" :src="banner.articlecarouselimg" fit="cover">
                            <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                        </el-image>
                        <div class="hero_overlay"></div>
                        <div class="hero_text" @click="showArticleDeltail(banner)">
                            <!-- 每切一张轮播，标题/正文重新上滑揭示 -->
                            <div class="hero_title ss-rise" :key="'heroT'+activeSlide" style="animation-delay:.12s">{{banner.articletitle}}</div>
                            <div class="hero_content ss-rise" :key="'heroC'+activeSlide" style="animation-delay:.34s">{{banner.articlecarouseltext}}</div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
            <div class="hero_scroll_hint" @click="goNextSection">
                <span>向下滚动</span>
                <i class="el-icon-arrow-down"></i>
            </div>
        </div>
    </div>

    <!-- ============ 第二屏：百年山水（资讯轮播 + 滚动资讯） ============ -->
    <!-- 注意：fullpage 会把 section 内容包进 fp-tableCell，真实 DOM 与 Vue vdom 不一致，
         子元素绝不能用 :key 重挂载（会导致元素从 DOM 消失），动画重播由 onSectionLoad 的
         class 重启机制统一驱动 -->
    <div class="section section_2">
        <div class="section_title ss-drop" style="animation-delay:.05s">
            <span class="title_main">百年山水</span>
            <span class="title_sub">A CENTURY OF SHANSHUI</span>
            <span class="title_deco"></span>
        </div>
        <div class="bnss_continer">
            <div class="bnss_carousel_box ss-from-left" style="animation-delay:.18s">
                <el-carousel class="bnss_el_carousel" height="100%" direction="horizontal" :autoplay="true" :interval="4000" arrow="hover">
                    <el-carousel-item v-for="banner in syzxBanners" :key="banner.articleid">
                        <div class="bnss_slide">
                            <!-- 模糊底图：同一张图放大虚化铺满舞台，消除 contain 的留白突兀 -->
                            <div v-if="banner.articlecarouselimg" class="bnss_blur_bg" :style="{backgroundImage:'url('+banner.articlecarouselimg+')'}"></div>
                            <!-- 原图完整展示：按图片自身比例缩放，横向/竖向/A4 通知都不裁切 -->
                            <img v-if="banner.articlecarouselimg" class="bnss_contain_img" :src="banner.articlecarouselimg" alt=""
                                 @error="e => { e.target.style.display='none' }">
                            <div v-if="!banner.articlecarouselimg" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="bnss_content_container ss-from-right" style="animation-delay:.32s">
                <div class="bnss_marque_title">集团资讯</div>
                <div class="bnss_marque_body">
                    <!-- 无缝循环：列表重复 4 组，动画位移 -25%（= 2 组 = 一个完整半区），
                         循环点前后画面完全一致；且保证半区高度 >= 可视区，内容少也不会露出空白。
                         之前只重复 2 份，资讯条数少时一份列表高度不够填满可视区，
                         滚到轨道底部会露出空白再从头循环，看起来"不是循环的"。 -->
                    <div class="bnss_marque_track" :class="{'run': activeSection===1}">
                        <div class="bnss_marque_group" v-for="g in 4" :key="'g'+g" :aria-hidden="g > 1 ? 'true' : null">
                            <div class="bnss_marque_container" v-for="item in syzxBanners" :key="g + '-' + item.articleid" @click="showArticleDeltail(item)">
                                <div class="bnss_marque_date">{{item.articledate}}</div>
                                <div class="bnss_marque_articleTile">{{item.articletitle}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="bnss_marque_btn">
                    <el-button type="primary" @click="$jumpTo('/xwzx')">MORE</el-button>
                </div>
            </div>
        </div>
    </div>

    <!-- ============ 第三屏：经典案例（杂志式不对称拼版） ============ -->
    <div class="section section_3">
        <div class="section3_title ss-drop" style="animation-delay:.05s">
            <span class="title_main">经典案例</span>
            <span class="title_sub">CLASSIC CASES</span>
            <span class="title_deco"></span>
            <div class="jdal_btns_container hidden-md-and-down">
                <button :class="{'jdal_btn_active': jdalActiveType==='all'}" @click="getAchievement()">全部</button>
                <button v-for="item in jdalTypeInfo" :key="item.achievementtype"
                        :class="{'jdal_btn_active': jdalActiveType===item.achievementtype}"
                        @click="changeJdalType(item.achievementtype)">{{item.typeName}}</button>
                <button class="jdal_btn_more" @click="$jumpTo('/yjzs')">更多 <i class="el-icon-arrow-right"></i></button>
            </div>
        </div>
        <div class="jdal_mosaic">
            <div class="jdal_btns_small_container hidden-lg-and-up">
                <button :class="{'jdal_btn_active': jdalActiveType==='all'}" @click="getAchievement()">全部</button>
                <button v-for="item in jdalTypeInfo" :key="item.achievementtype"
                        :class="{'jdal_btn_active': jdalActiveType===item.achievementtype}"
                        @click="changeJdalType(item.achievementtype)">{{item.typeName}}</button>
                <button class="jdal_btn_more" @click="$jumpTo('/yjzs')">更多 <i class="el-icon-arrow-right"></i></button>
            </div>
            <div class="jdal_grid">
                <div class="jdal_card ss-rise" :class="'jdal_pos_' + (idx % 6)" v-for="(item, idx) in jdalInfo" :key="item.achievementid"
                     :style="{'animation-delay': (0.15 + idx * 0.09) + 's'}" @click="showDetails(item)">
                    <div v-if="item.achievementfaceimg" class="jdal_card_img" :style="{backgroundImage: 'url(' + item.achievementfaceimg + ')'}"></div>
                    <div v-else class="jdal_card_img jdal_card_img_empty"><i class="el-icon-picture-outline"></i></div>
                    <div class="jdal_card_shade"></div>
                    <span class="jdal_card_type" v-if="jdalTypeName(item)">{{jdalTypeName(item)}}</span>
                    <span class="jdal_card_no">{{ '0' + (idx + 1) }}</span>
                    <div class="jdal_card_info">
                        <div class="jdal_card_name">{{item.achievementname}}</div>
                        <div class="jdal_card_more">查看项目 <i class="el-icon-right"></i></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- ============ 第四屏：联系我们 ============ -->
    <div class="section section_4">
      <el-row class="lxwm_container">
          <el-col :xs="24" :sm="24" :md="24" :lg="10" :xl="10" class="lxwm_left_container">
            <div class="section_4_title ss-from-left" style="animation-delay:.05s">联系我们
              <span class="title_deco"></span>
            </div>
            <div class="lxwm_marquee_container">
                <div class="lxwm_marquee">
                  <div class="lxwm_marquee_track" :class="{'run': activeSection===3}">
                    <!-- 无缝循环：4 组重复 + 位移 -25%，原理同第二屏资讯跑马灯 -->
                    <div class="lxwm_marquee_group" v-for="g in 4" :key="'cg'+g" :aria-hidden="g > 1 ? 'true' : null">
                      <div class="lxwm_marquee_item_container" v-for="item in lxwmInfo" :key="g + '-' + item.id">
                        <div class="lxwm_marquee_item_Name">{{item.name}}</div>
                        <div class="lxwm_marquee_item_Line"></div>
                        <div class="lxwm_marquee_item_address">
                          <div class="lxwm_marquee_item_address_tel">{{item.tel}}</div>
                          <div class="lxwm_marquee_item_address_add">{{item.province + item.city + item.address}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="14" :xl="14" class="lxwm_right_container ss-from-right" style="animation-delay:.2s">
            <el-image :src="section4BgImg" fit="cover">
              <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
              <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
            </el-image>
          </el-col>
      </el-row>
    </div>

    <!-- ============ 第五屏：宣传片 + 底部导航 ============ -->
    <div class="section section_5">
      <div class="section5_video_container ss-fade" style="animation-delay:.05s">
          <video-player  class="video-player vjs-custom-skin" id="videoDiv"
                ref="videoPlayer"
                :options="playerOptions"
                :playsinline="true"
                :webkit-playsinline="true"
                customEventName="customstatechangedeventname"
            >
          </video-player>
      </div>
      <el-row class="section5_navBottom_container">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bottomNavBar_container">
              <div class="bottomNavBar_item_container" v-for="menu in bootomInfo.bottomNavInfo" :key="menu.menuId" >
                  <div class="bottomNavBar_item_menu" @click="$jumpTo(menu.menuIndex)">{{menu.menuName}}</div>
                  <div class="bottomNavBar_item_subMenu_container">
                    <div class="bottomNavBar_item_subMenu" v-for="subMenu in menu.subMenu" :key="subMenu.subMenuId" @click="$jumpTo(menu.menuIndex)">{{subMenu.subMenuName}}</div>
                  </div>
              </div>
              <div class="bottomNavBar_item_container">
                  <div class="bottomNavBar_item_menu">关注我们</div>
                  <div class="bottomNavBar_item_subMenu_container">
                     <el-image :src="bootomInfo.emwUrl" fit="contain">
                        <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
                        <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                      </el-image>
                  </div>
              </div>
          </el-col>
           <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bottomText_container">
              <div>江苏山水环境建设集团股份有限公司 版权所有</div>
              <div>苏ICP备10039575号 江苏必得网络有限公司承建</div>
          </el-col>
      </el-row>
    </div>
</full-page>
</div>
</template>

<script>
export default {
  data () {
    return {
      activeSection: 0,
      activeSlide: 0,
      // 导航栏信息
      navBar: {
        isShowNavBar: false,
        sslogo: 'https://ssjt.buildone.com.cn/sslogo.png',
        navName: [
          { index: '/gyss', name: '关于山水' },
          { index: '/xwzx', name: '新闻中心' },
          { index: '/yjzs', name: '业绩展示' },
          { index: '/sswh', name: '山水文化' },
          { index: '/zxns', name: '招贤纳士' },
          { index: '/lxss', name: '联系山水' }
        ]
      },
      syBanners: [],
      syzxBanners: [],
      options: {
        // sectionsColor 会以内联样式写到 section 上，优先级高于本组件 scoped CSS，
        // 会把第四/五屏的深绿背景覆盖成浅色（白字全部"消失"）。全部留空，背景交给 CSS。
        sectionsColor: ['', '', '', '', ''],
        resize: true,
        scrollingSpeed: 900,
        navigation: true,
        navigationPosition: 'right',
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        // 重要：vue-fullpage.js 0.1.6 的 @after-load 事件是死代码（包装器构造的 events
        // 对象从未传给 fullpage，事件永远不触发），回调只能放 options（fullpage 核心直接调用）。
        // 但包装器会以「包装组件」为 this 调用 options 回调，因此必须用箭头函数
        // 捕获 data() 作用域里的 this（即本组件），在回调内部再用 this 访问本组件方法。
        afterLoad: (origin, destination) => {
          this.onSectionLoad(origin, destination)
        },
        // onLeave 在切换开始前触发：此刻目标屏还在屏幕外，提前重播入场动画，
        // 屏幕滑入时动画同步进行——若放到 afterLoad（切换结束后）重启，
        // 元素会先以结束态可见、再瞬间打回初始态重播，肉眼可见地"闪一下"。
        onLeave: (origin, destination) => {
          this.replaySectionAnimations(destination.index)
        }
      },
      jdalTypeInfo: [
        { achievementtype: 0, typeName: '设计' },
        { achievementtype: 1, typeName: '施工' },
        { achievementtype: 2, typeName: '监理' },
        { achievementtype: 3, typeName: '咨询' },
        { achievementtype: 4, typeName: '科研' }
      ],
      jdalActiveType: 'all',
      jdalInfo: [],
      section4BgImg: 'https://ssjt.buildone.com.cn/section3.jpg-sf',
      lxwmInfo: [],
      playerOptions: {
        autoplay: true,
        muted: true,
        loop: true,
        language: 'zh-CN',
        aspectRatio: '16:9',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{ type: 'video/mp4', src: '' }],
        width: '100%',
        controls: true,
        preload: 'auto'
      },
      bootomInfo: {
        emwUrl: 'https://ssjt.buildone.com.cn/ewm1.jpg',
        bottomNavInfo: [
          {
            menuId: 0,
            menuIndex: '/gyss',
            menuName: '关于山水',
            subMenu: [
              { subMenuId: 0, subMenuName: '山水介绍', subMenuIndex: '/ssjs' },
              { subMenuId: 1, subMenuName: '山水荣誉', subMenuIndex: '/ssry' },
              { subMenuId: 2, subMenuName: '成长历程', subMenuIndex: '/cclc' },
              { subMenuId: 3, subMenuName: '核心板块', subMenuIndex: '/hcmk' },
              { subMenuId: 4, subMenuName: '山水党建', subMenuIndex: '/ssdj' }
            ]
          },
          {
            menuId: 1,
            menuIndex: '/xwzx',
            menuName: '新闻中心',
            subMenu: [
              { subMenuId: 0, subMenuName: '企业新闻', subMenuIndex: '/ssjs' },
              { subMenuId: 1, subMenuName: '业内资讯', subMenuIndex: '/ssry' },
              { subMenuId: 2, subMenuName: '相关法规', subMenuIndex: '/cclc' }
            ]
          },
          {
            menuId: 2,
            menuIndex: '/yjzs',
            menuName: '业绩展示',
            subMenu: [
              { subMenuId: 0, subMenuName: '设计', subMenuIndex: '/sj' },
              { subMenuId: 1, subMenuName: '施工', subMenuIndex: '/sg' },
              { subMenuId: 2, subMenuName: '监理', subMenuIndex: '/jl' },
              { subMenuId: 3, subMenuName: '资讯', subMenuIndex: '/zx' },
              { subMenuId: 4, subMenuName: '科研', subMenuIndex: '/ky' }
            ]
          },
          {
            menuId: 3,
            menuIndex: '/sswh',
            menuName: '山水文化',
            subMenu: [
              { subMenuId: 0, subMenuName: '宣传片', subMenuIndex: '/xcp' },
              { subMenuId: 1, subMenuName: '员工风采', subMenuIndex: '/ssr' },
              { subMenuId: 2, subMenuName: '项目展示', subMenuIndex: '/ylzs' },
              { subMenuId: 3, subMenuName: '推荐文章', subMenuIndex: '/zwy' }
            ]
          },
          {
            menuId: 4,
            menuIndex: '/zxns',
            menuName: '招贤纳士',
            subMenu: [
              { subMenuId: 0, subMenuName: '人才招聘', subMenuIndex: '/rczp' },
              { subMenuId: 1, subMenuName: '人才理念', subMenuIndex: '/rcln' }
            ]
          },
          {
            menuId: 5,
            menuIndex: '/lxss',
            menuName: '联系山水',
            subMenu: [
              { subMenuId: 0, subMenuName: '联系我们', subMenuIndex: '/lxwm' },
              { subMenuId: 1, subMenuName: '资讯服务', subMenuIndex: '/ssry' },
              { subMenuId: 2, subMenuName: '周边旅游', subMenuIndex: '/zbly' }
            ]
          }
        ]
      }
    }
  },
  methods: {
    goNextSection () {
      if (this.$refs.fullpage && this.$refs.fullpage.api) {
        this.$refs.fullpage.api.moveSectionDown()
      }
    },
    // fullpage 区块进入时触发：状态同步 & 懒加载 & 滚动复位
    // （动画重播不在这里做——此时切换已完成、屏幕已可见，重启动画会闪一下；
    //   重播已前移到 onLeave → replaySectionAnimations）
    onSectionLoad (origin, destination) {
      this.activeSection = destination.index
      // 修复：滑回第二屏时轮播被"顶上去"。
      // 窄屏下 .bnss_continer 曾是 overflow-y:auto 的滚动容器，交互（点击箭头/圆点）
      // 会触发浏览器聚焦滚动把它的 scrollTop 顶起；滚轮已被 fullpage 接管，用户无法
      // 复位，只能刷新。容器已改为 overflow:clip（不可滚），此处再双保险归零。
      this.$nextTick(() => {
        const sections = document.querySelectorAll('.section')
        if (sections[destination.index]) sections[destination.index].scrollTop = 0
        const bnss = document.querySelector('.section_2 .bnss_continer')
        if (bnss) bnss.scrollTop = 0
      })
      if (destination.index === 2) this.getAchievement()
      if (destination.index === 4) this.getVideoByType()
    },
    // 重播某屏所有入场动画：先置 animation:none 摘掉，强制 reflow 后再恢复样式表动画。
    // 只在 onLeave（切换开始前、目标屏还在屏外）调用，动画与滑入同步播放、无闪烁。
    // 绝不能用 :key 重挂载——fullpage 初始化时把 section 内容包进了 fp-tableCell，
    // 真实 DOM 与 Vue vdom 不一致，重挂载会让元素直接从 DOM 里消失。
    replaySectionAnimations (sectionIndex) {
      const sec = document.querySelectorAll('.section')[sectionIndex]
      if (!sec) return
      sec.querySelectorAll('*').forEach(el => {
        if (el.nodeType !== 1) return
        const an = getComputedStyle(el).animationName
        if (an && an !== 'none') {
          const delay = el.style.animationDelay
          el.style.animation = 'none'
          // eslint-disable-next-line no-void
          void el.offsetWidth
          el.style.animation = ''
          if (delay) el.style.animationDelay = delay
        }
      })
    },
    // hero 轮播切换：只驱动首屏文字动画（hero 文字 :key 用 activeSlide，
    // 位于 el-carousel 自管子树内，重挂载安全）
    onSlideChange (index) {
      this.activeSlide = index
    },
    getCompanyList () {
      this.$http.get('/admin/getCompanyList').then(res => {
        this.lxwmInfo = res.data.data
      })
    },
    showDetails (data) {
      window.sessionStorage.setItem('jdalDetails', JSON.stringify(data))
      this.$router.push('jdalDetails')
    },
    loadAchievements (url, homepageOnly) {
      this.$http.get(url).then(res => {
        const info = res.data.data
        const tableData = []
        for (let index = 0; index < info.length; index++) {
          if (homepageOnly) {
            if (info[index].achievementshowhomepage === '1' && tableData.length < 6) tableData.push(info[index])
          } else if (tableData.length < 6) {
            tableData.push(info[index])
          }
        }
        this.jdalInfo = tableData
      })
    },
    getAchievement () {
      this.jdalActiveType = 'all'
      this.loadAchievements('/admin/getAchievement', true)
    },
    jdalTypeName (item) {
      const found = this.jdalTypeInfo.find(x => x.achievementtype === Number(item.achievementtype))
      return found ? found.typeName : ''
    },
    showArticleDeltail (data) {
      window.sessionStorage.setItem('articleDetail', JSON.stringify(data))
      window.sessionStorage.setItem('activeIndex', '/')
      this.$router.push('articleDetail')
    },
    clickNavBar () {
      this.navBar.isShowNavBar = !this.navBar.isShowNavBar
    },
    getcarouselList () {
      this.syBanners = []
      this.syzxBanners = []
      this.$http.get('/admin/getCarousel').then(res => {
        const data = res.data.data
        for (let index = 0; index < data.length; index++) {
          if (data[index].articlecarouseltype === '0') {
            this.syBanners.push(data[index])
          } else if (data[index].articlecarouseltype === '1') {
            if (data[index].articledate) data[index].articledate = data[index].articledate.substring(0, 11)
            this.syzxBanners.push(data[index])
          }
        }
      })
    },
    changeJdalType (typeId) {
      this.jdalActiveType = typeId
      this.loadAchievements('/admin/getAchievement/' + typeId, false)
    },
    getVideoByType () {
      this.$http.get('/admin/getVideoByType/0').then(res => {
        if (res.data.data.length > 0) {
          this.playerOptions.sources[0].src = res.data.data[0].videourl
        }
      }).catch(error => { console.log(error) })
    }
  },
  created () {
    this.getcarouselList()
    this.getCompanyList()
    this.getAchievement()
    this.getVideoByType()
  }
}
</script>

<style lang="less" scoped>
.home-root {
  // ===== 山水绿自然风 主题变量 =====
  --ss-green-900: #163a2b;
  --ss-green-800: #1f4d39;
  --ss-green-700: #2e6b4f;
  --ss-green-500: #3f8f6b;
  --ss-green-300: #8fc4a6;
  --ss-gold:      #c9a86a;
  --ss-sand:      #f7f5f0;
  --ss-ink:       #20302a;
  --ss-line:      rgba(46,107,79,.25);
  width: 100%;
  height: 100%;
}
.display_none { display: none !important; }

/* ============================================================
   自定义动画系统（山水自然风）
   触发机制：元素用 :key 绑定 activeSection/activeSlide，
   每次滚入该屏即重新挂载 -> 关键帧重播，往返滚动也能稳定触发。
   ============================================================ */
@keyframes ssRise   { from { opacity:0; transform: translateY(46px); } to { opacity:1; transform:none; } }
@keyframes ssDrop   { from { opacity:0; transform: translateY(-34px); } to { opacity:1; transform:none; } }
@keyframes ssLeft   { from { opacity:0; transform: translateX(-64px); } to { opacity:1; transform:none; } }
@keyframes ssRight  { from { opacity:0; transform: translateX(64px); }  to { opacity:1; transform:none; } }
@keyframes ssZoom   { from { opacity:0; transform: scale(.9); }         to { opacity:1; transform: scale(1); } }
@keyframes ssFade   { from { opacity:0; }                              to { opacity:1; } }
@keyframes ssLine   { from { transform: scaleX(0); }                   to { transform: scaleX(1); } }
.ss-rise,
.ss-drop,
.ss-from-left,
.ss-from-right,
.ss-zoom,
.ss-fade {
  animation-duration: .9s;
  animation-timing-function: cubic-bezier(.22,.61,.36,1);
  animation-fill-mode: both;
}
.ss-rise      { animation-name: ssRise; }
.ss-drop      { animation-name: ssDrop; }
.ss-from-left { animation-name: ssLeft; }
.ss-from-right{ animation-name: ssRight; }
.ss-zoom      { animation-name: ssZoom; animation-timing-function: cubic-bezier(.34,1.4,.64,1); } /* 略带回弹的缩放入场 */
.ss-fade      { animation-name: ssFade; animation-duration: 1s; animation-timing-function: ease; }
.ss-drop      { animation-duration: .8s; }

/* ===== 第一屏 ===== */
.section_1 { overflow: hidden; position: relative; background-color: var(--ss-green-900); }
.navbar_container {
  width: 100%; height: 100px;
  background-color: var(--ss-green-900);
  position: fixed; top: 0; z-index: 99;
  transition: background-color .4s ease, height .4s ease;
}
.navbar_container.navbar_transparent {
  background-color: rgba(22,58,43,.35);
  backdrop-filter: blur(4px);
}
.logo { height: 100%; display: flex; justify-content: flex-start; padding: 0 20px; align-items: center; }
.logo .el-image { width: 240px; height: 60px; cursor: pointer; }
.nav { height: 100%; display: flex; justify-content: flex-end; align-items: center; }
.nav_link { text-decoration: none; }
.nav .el-button--text { color: #fff; font-size: 100%; margin: 0 5px; transition: color .3s; }
.nav .el-button--text:hover { color: var(--ss-gold); }
.btns { padding: 0 20px; height: 100%; display: flex; justify-content: flex-end; align-items: center; }
.btns span { color: #fff; font-size: 200%; margin: 0 10px; cursor: pointer; transition: color .3s; }
.btns span:hover { color: var(--ss-gold); }

.navSM_container {
  width: 100%; position: fixed; top: 100px; z-index: 99; overflow: hidden;
  max-height: 0; transition: max-height .35s ease;
}
.navSM_container.open { max-height: 60vh; }
.navSM { background-color: rgba(22,58,43,.95); padding: 6px 0; }
.navSM .el-button--text { width: 100%; padding: 12px 0; color: #fff; letter-spacing: .1rem; }
.navSM .el-button--text:hover { color: var(--ss-gold); }

/* Hero 轮播 */
.hero_carousel { width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 10; }
.hero_el_carousel, .hero_el_carousel .el-carousel__container { height: 100% !important; }
.hero_slide { position: relative; width: 100%; height: 100%; overflow: hidden; }
.hero_img { width: 100%; height: 100%; display: block; animation: heroZoom 7s ease-out forwards; }
@keyframes heroZoom { from { transform: scale(1.08); } to { transform: scale(1); } }
.hero_overlay {
  position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(22,58,43,.55) 0%, rgba(22,58,43,.15) 40%, rgba(22,58,43,.75) 100%);
}
.hero_text {
  position: absolute; left: 0; bottom: 12%; z-index: 50; width: 100%;
  padding: 0 8%; color: #fff; cursor: pointer; text-shadow: 0 2px 8px rgba(0,0,0,.45);
}
.hero_title { font-size: 200%; letter-spacing: .1rem; font-weight: 600; max-width: 70%; }
.hero_title:hover { color: var(--ss-gold); }
.hero_content { font-size: 110%; line-height: 170%; margin-top: 12px; max-width: 60%; max-height: 5.5em; overflow: hidden; }
.hero_scroll_hint {
  position: absolute; bottom: 26px; left: 50%; transform: translateX(-50%); z-index: 60;
  color: #fff; font-size: 90%; letter-spacing: .15rem; display: flex; flex-direction: column;
  align-items: center; cursor: pointer; opacity: .85;
}
.hero_scroll_hint i { margin-top: 4px; animation: bounce 1.6s infinite; }
@keyframes bounce { 0%,100% { transform: translateY(0); } 50% { transform: translateY(8px); } }

/* ===== 区块通用标题 ===== */
.section_title, .section3_title {
  width: 100%; min-height: 110px; padding: 0 6%;
  display: flex; align-items: baseline; gap: 16px; position: relative;
  border-bottom: 1px solid var(--ss-line);
}
.title_main { font-size: 230%; color: var(--ss-green-800); font-weight: 700; letter-spacing: .1rem; }
.title_sub { font-size: 95%; color: var(--ss-green-300); letter-spacing: .25rem; font-weight: 300; }
/* 标题金线：从左向右描出 */
.title_deco {
  position: absolute; left: 6%; bottom: 14px;
  width: 64px; height: 4px; border-radius: 2px; background: var(--ss-gold);
  transform-origin: left center;
  animation: ssLine .7s .42s cubic-bezier(.22,.61,.36,1) both;
}

/* ===== 第二屏 ===== */
.section_2 { background-color: var(--ss-sand); }
.bnss_continer { height: calc(100% - 110px); width: 100%; display: flex; padding: 3% 6%; gap: 4%; box-sizing: border-box; overflow-anchor: none; }
.bnss_carousel_box {
  height: 100%; width: 56%; min-width: 200px;
  border-radius: 10px; overflow: hidden; box-shadow: 0 10px 30px rgba(22,58,43,.18);
  // 统一宽高比，杜绝轮播比例粗糙
  aspect-ratio: 16 / 9;
}
.bnss_el_carousel, .bnss_el_carousel .el-carousel__container { height: 100% !important; }
/* 轮播舞台：模糊底图 + 原图 contain 完整展示，任意比例（横图/竖图/A4 通知）都不裁切 */
.bnss_slide {
  position: relative; width: 100%; height: 100%;
  display: flex; align-items: center; justify-content: center;
  background: #0f2c1f; overflow: hidden;
}
.bnss_blur_bg {
  position: absolute; inset: -24px;
  background-size: cover; background-position: center;
  filter: blur(20px) brightness(.7) saturate(1.05);
}
.bnss_contain_img {
  position: relative; z-index: 1;
  display: block; max-width: 96%; max-height: 94%;
  width: auto; height: auto; object-fit: contain;
  border-radius: 6px; box-shadow: 0 14px 40px rgba(0,0,0,.45);
  background: #fff;
}
.bnss_content_container {
  height: 100%; width: 40%; min-width: 300px;
  display: flex; flex-direction: column; justify-content: center;
}
.bnss_marque_title { font-size: 170%; color: var(--ss-green-700); font-weight: 600; margin-bottom: 14px; position: relative; padding-left: 14px; }
.bnss_marque_title::before { content: ''; position: absolute; left: 0; top: 50%; transform: translateY(-50%); width: 5px; height: 60%; background: var(--ss-gold); border-radius: 3px; }
.bnss_marque_body { height: 46%; overflow: hidden; position: relative; mask-image: linear-gradient(180deg, transparent, #000 12%, #000 88%, transparent); }
.bnss_marque_track { will-change: transform; }
.bnss_marque_track.run { animation: newsScroll 22s linear infinite; }
.bnss_marque_body:hover .bnss_marque_track.run { animation-play-state: paused; }
/* 4 组重复列表，位移 -25%（= 2 组）无缝循环，速度与原「2 份 + -50%」一致 */
@keyframes newsScroll { from { transform: translateY(0); } to { transform: translateY(-25%); } }
.bnss_marque_container {
  height: 78px; display: flex; align-items: center; gap: 16px;
  border-top: 1px dashed var(--ss-line); cursor: pointer; padding: 0 6px;
  transition: background-color .25s;
}
.bnss_marque_container:hover { background-color: rgba(46,107,79,.06); }
.bnss_marque_date { min-width: 110px; color: var(--ss-gold); font-weight: 600; }
.bnss_marque_articleTile { line-height: 150%; color: var(--ss-ink); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.bnss_marque_btn { margin-top: 18px; }
.bnss_marque_btn .el-button {
  width: 150px; padding: 14px 0; background-color: var(--ss-green-800); border: unset; color: #fff; letter-spacing: .2rem;
}
.bnss_marque_btn .el-button:hover { background-color: var(--ss-green-700); }

/* ===== 第三屏：经典案例（杂志式不对称拼版网格） ===== */
.section_3 { background-color: var(--ss-sand); }
.section3_title { justify-content: space-between; position: relative; }
.jdal_btns_container { display: flex; gap: 10px; align-items: center; }
.jdal_btns_container button,
.jdal_btns_small_container button {
  font-size: 90%; border: 1px solid var(--ss-line); padding: 8px 24px; cursor: pointer;
  border-radius: 999px; background-color: transparent; color: var(--ss-green-700);
  letter-spacing: .05rem; transition: all .28s ease;
}
.jdal_btns_container button:hover, .jdal_btns_small_container button:hover {
  background-color: var(--ss-green-800); color: #fff; border-color: var(--ss-green-800);
}
.jdal_btns_container button.jdal_btn_active, .jdal_btns_small_container button.jdal_btn_active {
  background-color: var(--ss-green-800); color: #fff; border-color: var(--ss-green-800);
  box-shadow: 0 6px 16px rgba(31,77,57,.30);
}
.jdal_btns_container button.jdal_btn_more, .jdal_btns_small_container button.jdal_btn_more { border-style: dashed; }
.jdal_btns_small_container { display: flex; flex-wrap: wrap; gap: 8px; padding-bottom: 12px; }

.jdal_mosaic { height: calc(100% - 110px); padding: 2.2% 6% 3%; box-sizing: border-box; display: flex; flex-direction: column; }
/* 6 列 2 行拼版：左侧主视觉通栏高卡 + 两张宽幅卡 + 三张标准卡，错落有致 */
.jdal_grid {
  flex: 1; min-height: 0; display: grid; gap: 16px;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 1fr 1fr;
  grid-template-areas:
    'a a b b c c'
    'a a d e f f';
}
.jdal_pos_0 { grid-area: a; }
.jdal_pos_1 { grid-area: b; }
.jdal_pos_2 { grid-area: c; }
.jdal_pos_3 { grid-area: d; }
.jdal_pos_4 { grid-area: e; }
.jdal_pos_5 { grid-area: f; }

.jdal_card {
  position: relative; overflow: hidden; border-radius: 14px; cursor: pointer;
  background: #0f2c1f; box-shadow: 0 8px 22px rgba(22,58,43,.16);
  transition: box-shadow .4s ease, transform .4s ease;
}
.jdal_card:hover { box-shadow: 0 18px 40px rgba(22,58,43,.30); transform: translateY(-4px); }
.jdal_card_img {
  position: absolute; inset: 0; background-position: center; background-repeat: no-repeat; background-size: cover;
  transition: transform .65s cubic-bezier(.22,.61,.36,1);
}
.jdal_card:hover .jdal_card_img { transform: scale(1.06); }
.jdal_card_img_empty {
  display: flex; align-items: center; justify-content: center; font-size: 170%; color: rgba(255,255,255,.85);
  background: linear-gradient(135deg, var(--ss-green-700), var(--ss-green-900));
}
.jdal_card_shade {
  position: absolute; inset: 0;
  background: linear-gradient(180deg, rgba(15,44,31,0) 46%, rgba(15,44,31,.80) 100%);
  transition: background .4s ease;
}
.jdal_card:hover .jdal_card_shade { background: linear-gradient(180deg, rgba(15,44,31,.14) 0%, rgba(15,44,31,.84) 100%); }
.jdal_card_type {
  position: absolute; top: 14px; left: 14px; z-index: 2; padding: 4px 14px; border-radius: 999px;
  background: rgba(247,245,240,.92); color: var(--ss-green-800); font-size: 80%; font-weight: 600;
  letter-spacing: .08rem; backdrop-filter: blur(4px);
}
.jdal_card_no {
  position: absolute; top: 8px; right: 14px; z-index: 2; font-size: 130%; font-weight: 700; font-style: italic;
  color: rgba(255,255,255,.9); letter-spacing: .05rem; text-shadow: 0 2px 8px rgba(0,0,0,.4);
}
.jdal_card_info { position: absolute; left: 0; right: 0; bottom: 0; z-index: 2; padding: 14px 18px; color: #fff; }
.jdal_card_name { font-weight: 600; font-size: 105%; line-height: 1.45; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
/* 主视觉大卡：文字放大、可两行，更像封面专题 */
.jdal_pos_0 .jdal_card_name {
  font-size: 125%; white-space: normal; display: -webkit-box;
  -webkit-line-clamp: 2; -webkit-box-orient: vertical;
}
.jdal_pos_0 .jdal_card_info { padding: 20px 22px; }
.jdal_pos_0 .jdal_card_type { font-size: 92%; padding: 5px 16px; }
.jdal_pos_0 .jdal_card_no { font-size: 170%; }
.jdal_card_more {
  display: flex; align-items: center; gap: 6px; margin-top: 0; font-size: 82%; color: var(--ss-gold);
  letter-spacing: .14rem; max-height: 0; opacity: 0; overflow: hidden;
  transition: max-height .35s ease, opacity .35s ease, margin-top .35s ease;
}
.jdal_card:hover .jdal_card_more { max-height: 2.2em; opacity: 1; margin-top: 8px; }
.jdal_card_more i { transition: transform .3s ease; }
.jdal_card:hover .jdal_card_more i { transform: translateX(6px); }

/* ===== 第四屏 ===== */
.section_4 { background-color: var(--ss-green-800); }
.lxwm_container { width: 100%; height: 100%; padding: 4% 6%; box-sizing: border-box; display: flex; align-items: center; }
.lxwm_left_container { height: 100%; display: flex; flex-direction: column; justify-content: center; color: #fff; }
.section_4_title { font-size: 230%; color: #fff; font-weight: 700; letter-spacing: .1rem; margin-bottom: 24px; position: relative; padding-left: 16px; }
.section_4_title::before { content: ''; position: absolute; left: 0; top: 8px; bottom: 8px; width: 5px; background: var(--ss-gold); border-radius: 3px; }
.section_4_title .title_deco { left: 16px; bottom: -10px; }
.lxwm_marquee_container { width: 100%; }
.lxwm_marquee { width: 100%; height: 60vh; max-height: 460px; overflow: hidden; border-top: 1px solid rgba(255,255,255,.25); border-bottom: 1px solid rgba(255,255,255,.25); mask-image: linear-gradient(180deg, transparent, #000 10%, #000 90%, transparent); }
.lxwm_marquee_track { will-change: transform; }
.lxwm_marquee_track.run { animation: companyScroll 26s linear infinite; }
.lxwm_marquee:hover .lxwm_marquee_track.run { animation-play-state: paused; }
/* 4 组重复列表，位移 -25%（= 2 组）无缝循环 */
@keyframes companyScroll { from { transform: translateY(0); } to { transform: translateY(-25%); } }
.lxwm_marquee_item_container { height: 92px; width: 100%; display: flex; align-items: center; justify-content: space-around; border-top: 1px solid rgba(255,255,255,.18); }
.lxwm_marquee_item_Name { height: 80%; width: 38%; display: flex; justify-content: center; align-items: center; font-size: 150%; color: var(--ss-gold); }
.lxwm_marquee_item_Line { height: 60%; width: 2px; background-color: rgba(255,255,255,.4); }
/* 修复：分公司地址原来用浅绿(#eaf3ee)在深绿底上看不清，改为清晰近白，电话用金色做层次 */
.lxwm_marquee_item_address { height: 80%; width: 55%; font-size: 110%; color: #f3f8f5; font-weight: 500; letter-spacing: .02rem; }
.lxwm_marquee_item_address_tel { width: 100%; height: 50%; display: flex; align-items: center; color: var(--ss-gold); font-weight: 600; }
.lxwm_marquee_item_address_add { width: 100%; height: 50%; display: flex; align-items: center; }
.lxwm_right_container { height: 100%; border-radius: 10px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,.3); }
.lxwm_right_container .el-image { width: 100%; height: 100%; }

/* ===== 第五屏 ===== */
.section_5 { width: 100%; height: 100%; position: relative; background-color: #0d241b; }
.section5_video_container { width: 100%; height: 100%; position: absolute; top: 0; left: 0; z-index: 10; }
.section5_video_container .video-player { width: 100%; height: 100%; }
.section5_video_container video { width: 100% !important; height: 100% !important; object-fit: cover; }
#videoDiv > div { height: 100% !important; width: 100%; overflow: hidden; }
.section5_navBottom_container { width: 100%; max-height: 42%; background-color: rgba(20,48,36,.92); position: absolute; bottom: 0; z-index: 20; }
.section5_navBottom_container .bottomNavBar_container { height: 88%; padding: 18px 4%; display: flex; align-items: flex-start; justify-content: center; color: #eaf3ee; }
.bottomNavBar_item_container { height: 100%; padding: 0 2.2%; }
.bottomNavBar_item_menu { width: 100%; padding: 8px 4px; font-size: 118%; font-weight: 600; cursor: pointer; color: #fff; }
.bottomNavBar_item_subMenu { width: 100%; padding: 6px 4px; cursor: pointer; font-size: 92%; color: #bcd6c9; transition: color .25s; }
.bottomNavBar_item_menu:hover, .bottomNavBar_item_subMenu:hover { color: var(--ss-gold); }
.bottomNavBar_item_subMenu_container .el-image { width: 90px; }
.bottomText_container { height: 12%; background-color: #0a1c15; display: flex; justify-content: space-evenly; align-items: center; font-size: 80%; color: #9fc0b0; padding: 4px; letter-spacing: .05rem; }

/* ===== 响应式 ===== */
@media screen and (min-width: 1200px){
  .hero_title { font-size: 240%; }
}
@media screen and (max-width: 1024px) and (min-width: 501px){
  /* 桌面/平板下滚轮已被 fullpage 接管，容器不可滚：用 clip 彻底杜绝聚焦滚动顶起内容
     （clip = 非 scroll 容器，任何方式都滚不动；老浏览器不认识 clip 则降级为 hidden） */
  .bnss_continer { flex-direction: column; height: calc(100% - 110px); overflow-y: hidden; overflow-y: clip; gap: 18px; }
  /* 竖排时容器为滚动区，子项不许被 flex 压缩，保持 4/3 舞台完整、超出部分靠滚动查看 */
  .bnss_carousel_box { width: 100%; height: auto; aspect-ratio: 4 / 3; flex-shrink: 0; }
  .bnss_content_container { width: 100%; height: auto; flex-shrink: 0; }
  .bnss_marque_body { height: 240px; }
  .jdal_grid {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-areas: 'a b' 'c d' 'e f';
    gap: 12px;
  }
  .jdal_pos_0 .jdal_card_name { font-size: 108%; }
  .lxwm_container { flex-direction: column; }
  .lxwm_left_container, .lxwm_right_container { width: 100%; height: auto; }
  .lxwm_marquee { height: 300px; }
  .lxwm_right_container { margin-top: 20px; height: 280px; }
  .section5_navBottom_container { max-height: 55%; }
  .section5_navBottom_container .bottomNavBar_container { flex-wrap: wrap; }
}
@media screen and (max-width: 500px){
  .navbar_container { height: 80px; }
  .logo .el-image { width: 160px; height: 40px; }
  .navSM_container { top: 80px; }
  .section_title, .section3_title { min-height: 80px; padding: 0 5%; }
  .title_main { font-size: 170%; }
  .hero_text { bottom: 14%; padding: 0 6%; }
  .hero_title { font-size: 160%; max-width: 100%; }
  .hero_content { font-size: 95%; max-width: 100%; max-height: 4.5em; }
  .btns { padding: 0 14px; }
  .bnss_continer { flex-direction: column; height: calc(100% - 80px); overflow-y: auto; gap: 14px; padding: 16px 4%; }
  .bnss_carousel_box { width: 100%; height: auto; aspect-ratio: 1 / 1; flex-shrink: 0; }
  .bnss_content_container { width: 100%; height: auto; flex-shrink: 0; }
  .bnss_marque_body { height: 200px; }
  .bnss_marque_container { height: 64px; }
  .bnss_marque_date { min-width: 80px; font-size: 85%; }
  .jdal_btns_container { display: none; }
  .jdal_mosaic { height: calc(100% - 80px); padding: 12px 4% 16px; }
  .jdal_grid {
    display: flex; overflow-x: auto; gap: 12px; padding-bottom: 6px;
    -webkit-overflow-scrolling: touch; scroll-snap-type: x mandatory;
  }
  .jdal_card { flex: 0 0 78%; height: 100%; scroll-snap-align: center; }
  .lxwm_container { flex-direction: column; padding: 16px 4%; }
  .lxwm_left_container, .lxwm_right_container { width: 100%; height: auto; }
  .lxwm_marquee { height: 260px; }
  .lxwm_marquee_item_Name { font-size: 120%; width: 42%; }
  .lxwm_marquee_item_address { font-size: 88%; }
  .lxwm_right_container { margin-top: 16px; height: 220px; }
  .section5_navBottom_container { max-height: 64%; }
  .section5_navBottom_container .bottomNavBar_container { flex-wrap: wrap; }
  .bottomNavBar_item_container { width: 50%; height: auto; padding: 6px 8px; }
  .bottomText_container { flex-direction: column; font-size: 70%; }
}
</style>
